/* eslint-disable import/prefer-default-export */
export const CURRENT_EXERCISE = 'hk/CURRENT_EXERCISE';
